import { useState, useCallback } from 'react';

import { TABLET_BREAKPOINT } from '../../utils/constants';
import useResize from '../useResize/useResize';

const useIsTablet = () => {
  const [isTablet, setIsTablet] = useState(
    window.innerWidth <= TABLET_BREAKPOINT
  );
  const resize = useCallback(() => {
    if (window.innerWidth <= TABLET_BREAKPOINT) {
      setIsTablet(true);
    } else {
      setIsTablet(false);
    }
  }, []);
  useResize(resize);
  return isTablet;
};

export default useIsTablet;
